<template>
  <div class="sd-filters-div">
    <div class="sd-filter-header">
      Durchsuche die Wissensbasis
    </div>
    <div class="sd-filters-bar">
      <div class="sd-filters-wrapper">
        <div class="sd-filters-left">
          <div class="sd-filters-line">
            <label class="container">
              Öffentliche Tickets
              <input type="checkbox" v-model="jira" @click="emitSearch"
                id="jira-checkbox" :disabled="loader"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="sd-filters-line">
            <label class="container">
              Persönliche Tickets
              <input type="checkbox" v-model="personal" @click="emitSearch"
                id="personal-checkbox" :disabled="loader"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <div class="sd-filters-right">
          <div class="sd-filters-line">
            <label class="container">
              Confluence Dokumente
              <input type="checkbox" v-model="confluence" @click="emitSearch"
                id="confluence-checkbox" :disabled="loader || list"
              />
              <span class="checkmark" :class="list ? 'blocked' : ''"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="sd-filters-wrapper">
        <div class="sd-filters-left">
          <div class="sd-filters-line sd-sub-filter">
            <label class="container">
              Offene Tickets
              <input type="checkbox" v-model="opened" @click="emitSearch"
                :disabled="loader"
              />
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="sd-filters-line sd-sub-filter">
            <label class="container">
              Geschlossene Tickets
              <input type="checkbox" v-model="closed" @click="emitSearch"
                :disabled="loader"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <div class="sd-filters-right">
          <div class="sd-filters-line">
            Status:
            <select v-model="status" :disabled="loader || !opened"
              onsleect
            >
              <option v-for="(option, index) in statusOptions"
                :value="option.value" :key="index"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="sd-filters-wrapper">
        <input type="text" ref="searchInput" class="sd-text-input"
          v-model="search" placeholder="Suchbegriff"
          @keydown.enter.prevent.stop="emitSearch();"
        />

        <div class="sd-filters-center">
          <span class="sd-center-item">
            <label class="container">
              Details
              <input type="checkbox" v-model="cards" @click="emitSearch"
                id="confluence-checkbox" :disabled="loader"
              />
              <span class="radio"></span>
            </label>
          </span>
          <span class="sd-center-item">
            <label class="container">
              Liste
              <input type="checkbox" v-model="list" @click="emitSearch"
                id="confluence-checkbox" :disabled="loader"
              />
              <span class="radio"></span>
            </label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/Store';

export default {
  name: 'filters',
  store,

  computed: {
    cards: {
      get() {
        return this.$store.state.filters.displayCards;
      },
      set(value) {
        this.$store.dispatch('TOGGLE_DISPLAY', this.$store.state.filters);
      },
    },
    list: {
      get() {
        return this.$store.state.filters.displayList;
      },
      set(value) {
        this.$store.dispatch('TOGGLE_DISPLAY', this.$store.state.filters);
      },
    },
    search: {
      get() {
        return this.$store.state.filters.searchValue;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_VALUE', value);
      },
    },
    jira: {
      get() {
        return this.$store.state.filters.searchJira;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_JIRA', value);
      },
    },
    confluence: {
      get() {
        return this.$store.state.filters.searchConfluence;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_CONFLUENCE', value);
      },
    },
    personal: {
      get() {
        return this.$store.state.filters.searchPersonal;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_PERSONAL', value);
      },
    },
    closed: {
      get() {
        return this.$store.state.filters.searchClosed;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_CLOSED', value);
      },
    },
    opened: {
      get() {
        return this.$store.state.filters.searchOpened;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_OPENED', value);
      },
    },
    status: {
      get() {
        return this.$store.state.filters.searchStatus;
      },
      set(value) {
        this.$store.commit('SET_SEARCH_STATUS', value);
      },
    },
    statusOptions: {
      get() {
        return this.$store.state.filters.statusOptions;
      },
    },
    loader() {
      return this.$store.state.loader;
    },
    sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder() {
      return this.$store.state.filters.sortOrder;
    },
  },

  watch: {
    status() {
      this.emitSearch();
    },
  },

  methods: {
    emitSearch() {
      if (this.loader) {
        return;
      }
      this.$nextTick(() => {
        this.$parent.$emit('emitSearch');
      });
    },
  },
};
</script>

<style lang="scss">
@import "./../../Globals.scss";

.sd-filters-div {
  max-width: $sd-max-width;
  margin: auto;
  margin-top: 15px;
  position: relative;
  z-index: 10;

  .sd-filter-header {
    padding: 7px 0 7px 5%;
    text-align: left;
    background-color: $sd-color-blue;
    color: white;
    font-size: 14px;
    font-weight: bold;
    box-shadow: $sd-box-shadow;
  }

  .sd-filters-bar {
    text-align: left;
    padding: 15px;
    background-color: white;
    color: $sd-color-dark-blue;
    box-shadow: $sd-box-shadow;

    .sd-filters-wrapper {
      width: 90%;
      display: table;
      padding: 0px 5% 0px 5%;

      select {
        padding: 0 5px;
        background: white;
      }

      .sd-filters-left {
        display: table-cell;
        width: 50%;
      }

      .sd-filters-right {
        display: table-cell;
        width: 50%;
      }

      .sd-filters-center {
        text-align: center;
        padding: 15px 0;
        width: 100%;

        .sd-center-item {
          padding: 0 10px;
        }
      }

      .sd-filters-line {
        margin-bottom: 15px;
      }

      .sd-sub-filter {
        width: 50%;
        display: table-cell;
      }

      .container {
        position: relative;
        padding: 2px 0 0 25px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
        }

        &:hover {
          input ~ span {
            opacity: 0.8;
          }
        }

        input:checked ~ span {
          background-color: $sd-color-blue;
          border: solid $sd-color-blue 2px;
        }

        span {
          position: absolute;
          top: 0;
          left: 0;
          height: 15px;
          width: 15px;
          background-color: #eee;
          border: solid $sd-color-lightgrey 2px;
          border-radius: 2px;
        }

        .radio {
          border-radius:50%;
        }

        span:after {
          content: "";
          position: absolute;
          display: none;
        }

        input:checked ~ span:after {
          display: block;
        }

        span:after {
          left: 4px;
          top: 0px;
          width: 5px;
          height: 10px;
          border: solid white;
          border-width: 0 2px 2px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }

        .blocked {
          background-color: $sd-color-lightgrey-05;
          border: solid $sd-color-lightgrey-05 2px;
        }
      }

      .sd-text-input {
        width: 100%;
        border: none;
        padding-top: 10px;
        font-size: 14px;
        border-bottom: solid 1px #ddd;
        transition: border-bottom 0.5s ease;
      }

      input.sd-text-input:focus {
        outline-width: 0;
        border-bottom: solid 1px $sd-color-blue;;
      }
    }

    .sd-half {
      width: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Filters.vue?2abf74f3